import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b94caa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "accept", "data-testid"]
const _hoisted_2 = { class: "button-wrapper" }
const _hoisted_3 = { class: "button-text pl-1" }

import { ref } from 'vue'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import {
  InputFileValidator,
  InputError,
} from '@/popup/components/shared/Form/FormTypes'
import { HTMLInputEvent } from '@/typings/html-input-events'

type Props = {
  validators?: InputFileValidator[]
  isRequired?: boolean
  name?: string
  fileType?: string
}

type Emits = {
  (event: 'on-file-selected', file: File): void
  (event: 'on-errors', errors: InputError[]): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'File',
  props: {
    validators: { default: undefined },
    isRequired: { type: Boolean },
    name: { default: '' },
    fileType: { default: undefined }
  },
  emits: ["on-file-selected", "on-errors"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const element = ref<HTMLInputElement>()

const handleFile = async (file: File) => {
  const errors = await validate(file)
  if (errors && errors.length > 0) {
    emits('on-errors', errors)
  } else {
    emits('on-file-selected', file)
  }
}
const onChange = async (event: Event) => {
  ;(event as HTMLInputEvent).target.focus()
  const files = (event as HTMLInputEvent).target.files
  if (files !== null) {
    const file = files[0]
    handleFile(file)
  }
}

const validate = async (file: File) => {
  if (file && props.validators) {
    const validationErrors_ = await Promise.all(
      props.validators
        ?.map(async validator => await validator(file))
        .filter(Boolean)
    )
    const validationError = validationErrors_.filter(Boolean)
    if (validationError && validationError.length > 0) {
      return validationError
    }
  }
}

const fileClick = async () => {
  element.value?.click()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      ref_key: "element",
      ref: element,
      id: `${_ctx.name}-file-picker`,
      type: "file",
      accept: _ctx.fileType,
      hidden: "",
      "data-testid": _ctx.name ? `file-${_ctx.name}` : 'file',
      onChange: onChange
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Button, {
        variant: "secondary",
        size: "small",
        onClick: fileClick
      }, {
        default: _withCtx(() => [
          _createVNode(SvgIcon, {
            name: "search",
            class: "is-flex",
            height: "16",
            width: "16"
          }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('components.file.button_text')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})